import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { getC3TransactionColumns, type C3Transaction } from "./columns";
import {
  type FilterC3TransactionsSchema,
  FilterC3Transactions,
} from "./filter";

export const C3TransactionsTable = () => {
  const { t } = useTranslation();
  const columns = getC3TransactionColumns(t);

  return (
    <Table<C3Transaction, FilterC3TransactionsSchema>
      label={t(`${Tables.C3_TRANSACTIONS}.title`, {
        ns: "tables",
        defaultValue: "Transactions",
      })}
      client={Clients.C3}
      table_name={Tables.C3_TRANSACTIONS}
      columns={columns}
      filter={<FilterC3Transactions />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C3}/${Tables.C3_TRANSACTIONS}/new`,
        },
      ]}
    />
  );
};
